import React from 'react';

export default function MapSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="mx-auto max-w-[var(--container-max)] px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="text-sm font-semibold text-[var(--color-accent)] uppercase tracking-wider mb-3">
            Elhelyezkedés
          </div>
          <h2 className="text-3xl md:text-4xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] tracking-tight">
            Látogasson el bemutatótermünkbe
          </h2>
        </div>

        {/* Map */}
        <div className="rounded-2xl overflow-hidden shadow-[var(--shadow-md)] aspect-video">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3635.363597307089!2d22.06848371281099!3d48.20644487113132!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4738ecd91b133f8f%3A0x7d51328ff4086370!2zWEwgQsO6dG9yLCBTesWRbnllZyBWZWd5ZXNrZXJlc2tlZMOpcw!5e1!3m2!1shu!2shu!4v1761558750278!5m2!1shu!2shu"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="XL bútor - Kisvárda"
          ></iframe>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          <div className="bg-[var(--color-bg)] rounded-xl p-6 text-center">
            <div className="text-3xl mb-3">📍</div>
            <div className="font-semibold text-[var(--color-text-primary)] mb-2">Cím</div>
            <div className="text-sm text-[var(--color-text-secondary)]">
              Kisvárda<br />Attila u. 61, 4600
            </div>
          </div>

          <div className="bg-[var(--color-bg)] rounded-xl p-6 text-center">
            <div className="text-3xl mb-3">🕐</div>
            <div className="font-semibold text-[var(--color-text-primary)] mb-2">Nyitvatartás</div>
            <div className="text-sm text-[var(--color-text-secondary)]">
              Hétfő - Péntek: 9:00 - 17:00<br />
              Szombat: 9:00 - 13:00
            </div>
          </div>

          <div className="bg-[var(--color-bg)] rounded-xl p-6 text-center">
            <div className="text-3xl mb-3">🚗</div>
            <div className="font-semibold text-[var(--color-text-primary)] mb-2">Parkolás</div>
            <div className="text-sm text-[var(--color-text-secondary)]">
              Ingyenes parkolás<br />az épület előtt
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

